module.exports = __webpack_public_path__ + "static/media/take_actiongrn.bd3e23cb.png";